import { Tile } from "./tile"
import { TILE_CATALOG } from "./constants"
import type { TileDefinition } from "./types"

/** Build deck from catalog: expand each definition by its count */
export function buildDeckFromCatalog(catalog: TileDefinition[] = TILE_CATALOG): Tile[] {
  const deck: Tile[] = []
  for (const def of catalog) {
    for (let i = 0; i < def.count; i++) {
      deck.push(Tile.create(def.terrain, def.animal, def.edgePattern))
    }
  }
  return deck
}

/** Seeded pseudo-random number generator (mulberry32) */
function mulberry32(seed: number): () => number {
  return () => {
    seed |= 0
    seed = (seed + 0x6D2B79F5) | 0
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

/** Fisher-Yates shuffle (in-place). Optional seed for deterministic shuffles. */
export function shuffle<T>(array: T[], seed?: number): T[] {
  const random = seed !== undefined ? mulberry32(seed) : Math.random
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]
  }
  return array
}

/** Build and shuffle a full deck */
export function buildDeck(seed?: number): Tile[] {
  const deck = buildDeckFromCatalog()
  return shuffle(deck, seed)
}
